import React, { useState } from 'react';
import './input.css';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';

const InputField = ({ label, placeholder, type, onChange, paddingBottom, maxlength, countryCode, validatePhone = false, value, }) => {
  const [focused, setFocused] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';
  const inputType = isPasswordField && showPassword ? 'text' : type;

  const handleChange = (event) => {
    const value = event.target.value;

    // Validate phone number on each change
    if (type === 'number' && validatePhone) {
      const valid = isValidPhoneNumber(value, countryCode);
      setIsValid(valid);
    } else {
      setIsValid(true); // reset isValid if no validation is required
    }

    // Call the onChange callback
    onChange(value);
  };

  return (
    <div>
      <label className={focused ? 'label-input focused' : 'label-input'}>
        {label}
      </label>
      <div className="input-field-wrapper">
        <input
          type={inputType}
          onChange={handleChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          maxLength={maxlength}
          value={value}
          className={`input-feild-custom ${isPasswordField ? 'password-input' : ''} ${!isValid ? 'invalid' : ''}`}
          style={{
            borderBottom: '1px solid white',
            paddingBottom: paddingBottom || '10px',
          }}
        />
        {isPasswordField && (
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
          </button>
        )}
      </div>
      {!isValid && type === 'number' && validatePhone && (
        <p className="error-message">Invalid phone number</p>
      )}
    </div>
  );
};

export default InputField;
